<script>
    // コンポーネントで使用する共通処理を定義する
    // メソッド名の先頭に必ず「common」を付ける
    export default {
        name: "CommonMethod",
        methods: {
            // CSV出力共通処理
            commonDownloadCSV(exportData) {

                // 初期化
                var exportLineData = null;
                var fileName = null;

                // 出力データ、ファイル名を取得
                exportLineData = exportData['data'];
                fileName = this.commonFileNameCSV(exportData['headers']['content-disposition'])

                try {
                    // 文字コード及びヘッダーを設定
                    var csv = '\ufeff' + exportLineData + '\n'
                    // 出力形式を設定
                    let blob = new Blob([csv], { type: 'text/csv' })
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    // ファイル名を指定
                    link.download = fileName;
                    link.click()
                }
                catch (e) {
                    return false;
                }
                return true;
            },
            // CSV出力ファイル名加工処理
            commonFileNameCSV(fileName){
                let str = "filename*=utf-8''";
                let index = fileName.indexOf(str);
                if (index != -1) {
                    let sliceFileName = fileName.slice(index);
                    return decodeURIComponent(sliceFileName.replace(str, ''));
                } else {
                    return fileName.replace('attachment; filename=', '')
                }
            }
        }
    }
</script>